import {
    FETCH_COMPANY_PAYMENT_OPTIONS,
} from '../types';
import api from '../api';

export const fetchCompanyPaymentOptions = (companyId) => {
    return {
        type: FETCH_COMPANY_PAYMENT_OPTIONS,
        payload: api.company.get(companyId).paymentOptions(),
    };
};
